import {
  CREATE_PLC_SAFETY_TRIGGER,
  CREATE_PLC_SAFETY_TRIGGER_SUCCESSFUL,
  CREATE_PLC_SAFETY_TRIGGER_FAILED,
} from './actionTypes';

export const createPlcSafetyTrigger = (trigger) => ({
  type: CREATE_PLC_SAFETY_TRIGGER,
  payload: { trigger },
});

export const createPlcSafetyTriggerSuccessful = (message) => ({
  type: CREATE_PLC_SAFETY_TRIGGER_SUCCESSFUL,
  payload: message,
});

export const createPlcSafetyTriggerFailed = (message) => ({
  type: CREATE_PLC_SAFETY_TRIGGER_FAILED,
  payload: message,
});
